import React from 'react';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';

import { Brand, Site } from '@swf/core/enums';
import { select } from '@swf/core/store';

const StarsFavIcon: React.FC = () => {
  const site = useSelector(select.site.getId);
  const brand = useSelector(select.site.getBrand);
  const favicon = useSelector(select.page.getFavicon);

  let faviconUrl = favicon;

  if (!faviconUrl) {
    switch (true) {
      case brand === Brand.FullTilt:
        faviconUrl = '/favicon-fulltilt.ico';
        break;
      case brand === Brand.FoxBet:
        faviconUrl = '/favicon-foxbet.ico';
        break;
      case site === Site.DESH:
        faviconUrl = '/favicon-desh.ico';
        break;
      default:
        faviconUrl = '/favicon.ico';
        break;
    }
  }

  return (
    <Helmet>
      <link rel="shortcut icon" href={faviconUrl} />
    </Helmet>
  );
};

export default StarsFavIcon;
